// Sharing utilities for Kotlin/Wasm interop

/** Opens the browser's native share sheet, falling back to a confirmed clipboard copy. */
export async function shareLink(link, onResult) {
    const data = {url: link};
    try {
        if (typeof navigator.share === "function" && (typeof navigator.canShare !== "function" || navigator.canShare(data))) {
            // Call before any await so the click's transient user activation is preserved.
            await navigator.share(data);
            onResult("shared");
            return;
        }
    } catch (error) {
        if (error?.name === "AbortError") {
            onResult("cancelled");
            return;
        }
        // A second click while the native sheet is open must not copy behind it.
        if (error?.name === "InvalidStateError") {
            onResult("failed");
            return;
        }
    }

    await copyToClipboard(
        link,
        () => onResult("copied"),
        () => onResult("failed"),
    );
}

/**
 * Copies text to the clipboard
 * @param {string} text - The text to copy
 * @param {function} onSuccess - Callback on successful copy
 * @param {function} onFailure - Callback on failure
 */
export async function copyToClipboard(text, onSuccess, onFailure) {
    try {
        await navigator.clipboard.writeText(text);
    } catch {
        onFailure();
        return;
    }
    onSuccess();
}
